module.exports = __webpack_public_path__ + "img/ws.096fc500.svg";